module.exports = __webpack_public_path__ + "img/mb-eqesuv.7f5d4c7f.jpg";